import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'

const getDefaultState = () => {
    return {
        loadingPage: false,
        updatingPage: false,
        id: null,
        title: '',
        type: 0,
        keywords: '',
        description: '',
        thumbnail: '',
        keyBody: Math.random(),
        body: '',
        url: '',
        deleted: false,
        created: null,
        updated: null,
        deletedAt: null,
        errors: {},
        flag: {
            type: '',
            text: ''
        }
    }
}

const normalize = (value) => String(value || '').trim()

const validate = (instance) => {
    const errors = {
        title: '',
        body: '',
        keywords: '',
        description: '',
        thumbnail: '',
        type: ''
    }

    const title = normalize(instance.state.title)
    const body = normalize(instance.state.body)
    const keywords = normalize(instance.state.keywords)
    const description = normalize(instance.state.description)
    const thumbnail = instance.state.thumbnail
    const type = Number(instance.state.type)

    if (!title) {
        errors.title = 'Required'
    }
    else if (title.length > 700) {
        errors.title = 'Too long'
    }

    if (!body) {
        errors.body = 'Required'
    }

    if (keywords.length > 200) {
        errors.keywords = 'Too long'
    }

    if (description.length > 400) {
        errors.description = 'Too long'
    }

    if (typeof thumbnail === 'string' && normalize(thumbnail).length > 1000) {
        errors.thumbnail = 'Too long'
    }

    if (type !== 0 && type !== 1) {
        errors.type = 'Invalid type'
    }

    const valid = Object.keys(errors).every((key) => errors[key].length === 0)
    instance.setState({
        ...instance.state,
        errors,
        flag: {
            type: valid ? '' : 'error',
            text: valid ? '' : 'Validation Failure'
        }
    })

    return valid
}

const mapBackendErrors = (errorPayload) => {
    if (!errorPayload) {
        return {}
    }

    if (Array.isArray(errorPayload)) {
        const mapped = {}
        errorPayload.forEach((item) => {
            if (item && item.field) {
                mapped[item.field] = item.message || 'Invalid value'
            }
        })
        return mapped
    }

    if (typeof errorPayload === 'object') {
        return errorPayload
    }

    return {}
}

const parsePage = (responseData) => {
    const data = responseData && responseData.data ? responseData.data : {}
    return data.page || data.item || data
}

const loadPage = (instance) => {
    instance.setState({ ...instance.state, loadingPage: true })

    axios({
        method: 'post',
        url: API_ENDPOINT + '/api/content/page',
        headers: {
            Authorization: store.getState().auth.authorizationToken
        },
        data: {
            id: instance.props.match.params.id
        }
    }).then((response) => handleLoadResponse(instance, response))
        .catch((error) => {
            instance.setState({
                ...instance.state,
                loadingPage: false,
                flag: {
                    type: 'error',
                    text: 'Failed to load page. Please retry.'
                }
            })
            alert(error)
        })
}

const handleLoadResponse = (instance, response) => {
    if (response.status === 200 && response.data.status === 200) {
        const page = parsePage(response.data)
        const keepSuccessFlag = instance.state.flag && instance.state.flag.type === 'success'
        instance.setState({
            ...instance.state,
            loadingPage: false,
            id: page.id,
            title: page.title || '',
            type: Number(typeof page.type === 'undefined' ? 0 : page.type),
            keywords: page.keywords || '',
            description: page.description || '',
            thumbnail: page.thumbnail || '',
            body: page.body || '',
            keyBody: Math.random(),
            url: page.url || '',
            deleted: Boolean(page.deleted),
            created: page.createdAt || page.created || null,
            updated: page.updatedAt || page.updated || null,
            deletedAt: page.deletedAt || null,
            flag: keepSuccessFlag ? instance.state.flag : {
                type: '',
                text: ''
            }
        })
        return
    }

    if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
        return
    }

    instance.setState({
        ...instance.state,
        loadingPage: false,
        flag: {
            type: 'error',
            text: response.data.message || 'Page not found.'
        }
    })
}

const updatePage = (instance) => {
    if (instance.state.updatingPage) {
        return
    }

    instance.setState({
        ...instance.state,
        updatingPage: true,
        flag: {
            type: '',
            text: ''
        }
    })

    const formData = new FormData()
    const pageId = instance.state.id || instance.props.match.params.id
    formData.append('id', pageId)
    formData.append('title', normalize(instance.state.title))
    formData.append('url', normalize(instance.state.url))
    formData.append('body', instance.state.body)
    formData.append('keywords', normalize(instance.state.keywords))
    formData.append('description', normalize(instance.state.description))
    formData.append('type', Number(instance.state.type))

    if (instance.state.thumbnail instanceof File) {
        formData.append('thumbnail', instance.state.thumbnail)
    }

    axios({
        method: 'post',
        url: API_ENDPOINT + '/api/content/page/update',
        headers: {
            Authorization: store.getState().auth.authorizationToken
        },
        data: formData
    }).then((response) => handleUpdateResponse(instance, response))
        .catch((error) => {
            instance.setState({
                ...instance.state,
                updatingPage: false,
                flag: {
                    type: 'error',
                    text: 'Failed to update page. Please retry.'
                }
            })
            alert(error)
        })
}

const handleUpdateResponse = (instance, response) => {
    if (response.status === 200 && response.data.status === 200) {
        const page = parsePage(response.data)
        instance.setState({
            ...instance.state,
            updatingPage: false,
            url: page && page.url ? page.url : instance.state.url,
            updated: (page && (page.updatedAt || page.updated)) || instance.state.updated,
            flag: {
                type: 'success',
                text: 'Page updated successfully.'
            }
        })

        loadPage(instance)
        return
    }

    if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
        return
    }

    const backendErrors = mapBackendErrors(response.data.errors || (response.data.data && response.data.data.errors))
    instance.setState({
        ...instance.state,
        updatingPage: false,
        errors: {
            ...instance.state.errors,
            ...backendErrors
        },
        flag: {
            type: 'error',
            text: response.data.message || 'Update failed.'
        }
    })
}

const EditPageWorker = (instance) => {
    return {
        getDefaultState: () => getDefaultState(),
        isValid: () => validate(instance),
        loadPage: () => loadPage(instance),
        updatePage: () => updatePage(instance)
    }
}

export default EditPageWorker
